import React, { useState, useEffect } from "react";

const CookiesPopup = () => {
  const [showPopup, setShowPopup] = useState(false);

  useEffect(() => {
    // Cek apakah pengguna sudah setuju cookies sebelumnya
    const cookiesAccepted = localStorage.getItem("cookiesAccepted");
    if (!cookiesAccepted) {
      setShowPopup(true);
    }
  }, []);

  const handleAcceptCookies = () => {
    localStorage.setItem("cookiesAccepted", "true");
    setShowPopup(false);
  };

  if (!showPopup) return null;

  return (
    <div className="bg-dark text-light fixed-bottom py-3">
      <div className="container d-flex flex-column flex-md-row justify-content-between align-items-center">
        <p className="mb-2 mb-md-0">
          Klik <span className="text-primary text-decoration-underline">"Setuju"</span> jika Anda setuju untuk menggunakan cookie di situs web kami. Kami menggunakan cookie untuk meningkatkan pengalaman Anda di situs web kami. Untuk memahami kebijakan Privasi kami terhadap cookie yang kami gunakan, silakan akses halaman <a href="/kebijakan-privasi" className="text-primary text-decoration-underline">Kebijakan Privasi</a>.
        </p>
        <button
          type="button"
          className="btn btn-primary"
          onClick={handleAcceptCookies}
        >
          Setuju
        </button>
      </div>
    </div>
  );
};

export default CookiesPopup;